/**
 * Application roles — Keycloak realm roles, single source of truth.
 *
 * Values are the literal Keycloak role names. `app/types/roles.ts` re-exports
 * these for backwards compatibility with the documented `~/types/roles` path.
 */
export enum AppRole {
  ADMIN = 'hello-admin',
  AMESURA = 'hello-amesura',
  CLIENT = 'hello-client',
}

/**
 * Role resolution priority: when a user carries several roles, the first match
 * in this order wins (admin outranks amesura outranks client).
 */
export const ROLE_PRIORITY: AppRole[] = [AppRole.ADMIN, AppRole.AMESURA, AppRole.CLIENT];

/**
 * Roles assignable to internal (non-client) users from the back office.
 * Future internal roles (e.g. project manager) get appended here.
 */
export const INTERNAL_ASSIGNABLE_ROLES = [AppRole.ADMIN, AppRole.AMESURA] as const;
export type InternalAssignableRole = (typeof INTERNAL_ASSIGNABLE_ROLES)[number];
